import OurValues from "../components/our-values";
import "../../company.css";
import OurTeamSection from "../components/team-section";
import AboutTeam from "../components/about-section";
import AboutUsHero from "../components/about-us-hero";
import ContactForm from "../../../../components/forms/contact-form";
import ProductPartners from "../../../../components/product-partners";
import { useScroll } from "../../../../context/scroll-context";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import EmployeeCarousel from "../../../../components/carousels/employee-carousel";

const AboutUs = () => {
    const { ourTeam, scrollToSection } = useScroll();
    const location = useLocation();

    useEffect(() => {
        if (location.pathname === "/company/about_us/our-team") {
            if (ourTeam && ourTeam.current) {
                scrollToSection(ourTeam);
            }
        }
    }, [location.pathname, ourTeam, scrollToSection]); // Ensure dependencies include `ourTeam` and `scrollToSection`

    return (
        <section className="about-page-wrapper">
            <AboutUsHero />
            <AboutTeam />
            <OurValues />
            <div ref={ourTeam}>
                <OurTeamSection />
            </div>
            <EmployeeCarousel />
            <ContactForm />
            <ProductPartners />
        </section>
    );
};

export default AboutUs;
